import { Image } from 'components/Image'

export const overlayTexteDE: {
  date: string
  type?: 'text' | 'title'
  data: OverlayData
}[] = [
  {
    date: '2021-03-01',
    data: {
      date: '1. März 2021',
      title: 'Die Vorgeschichte',
      text: (
        <>
          Der Greensill-Skandal erschüttert die Credit Suisse. Im Zuge des
          Debakels muss die Grossbank Fonds mit Anlagen von 10 Milliarden
          Franken schliessen. Im selben Monat trifft die CS der Kollaps des
          US-Hedgefonds Archegos. Die Folge sind milliardenschwere Verluste. Die
          Aktie verliert deutlich an Wert.
        </>
      ),
      links: [
        {
          text: 'Wie aus einem todsicheren Geschäft eine Pleite wurde',
          href: '454799729909',
        },
        {
          text: 'Credit Suisse war bei Greensill gewarnt',
          href: '366309456091',
        },
        { text: 'Credit-Suisse-Aktie stürzt ab', href: '302986354886' },
      ],
    },
  },

  {
    date: '2021-04-22',
    data: {
      date: '22. April 2021',
      title: 'Archegos-Verlust wächst auf 5 Milliarden',
      text: (
        <>
          Die CS kündigt neue Verluste durch den Zusammenbruch des US-Hedgefonds
          Archegos an. «Für das zweite Quartal rechnen wir mit einer
          verbleibenden Belastung von 600 Millionen Franken», so die Bank. Damit
          summiert sich der Verlust auf 5 Milliarden Franken.
        </>
      ),
      links: [
        {
          text: 'Verlust wächst auf 5 Milliarden, Aktie fällt unter 9 Franken',
          href: '712484612594',
        },
      ],
    },
  },
  {
    date: '2021-04-30',
    data: {
      date: '30. April 2021',
      title: 'Rohner tritt ab',
      text: (
        <>
          <Image
            src={require('./Images/rohner.jpg')}
            caption='Urs Rohner'
            source='Foto: Iris C. Ritter (FuW)'
          />
          Nach zehn Jahren nimmt CS-Präsident Urs Rohner nach der Greensill- und
          Archegos-Krise den Hut. Die Generalversammlung wählt António
          Horta-Osório zum Nachfolger. Insgesamt kassierte er rund 42 Millionen
          Franken an Salär. In seiner Amtszeit kehrte sich der Börsentrend ins
          Negative: Der Kurs sank von 35 auf unter 10 Franken.
        </>
      ),
      links: [
        {
          text: 'Bussen, Salär, Aktie – so teuer war die Ära Rohner',
          href: '589843010962',
        },
      ],
    },
  },
  {
    date: '2021-06-17',
    data: {
      date: '17. Juni 2021 ',
      title: 'Lob und Warnung von der SNB',
      text: (
        <>
          Die CS sei «gut aufgestellt, um die Herausforderungen des aktuellen
          Umfelds zu meistern und die Realwirtschaft zu unterstützen», schreibt
          die SNB in ihrem Bericht zur Finanzstabilität 2021. Gleichzeitig sei
          das Verlustpotenzial der beiden Banken unter Stressszenarien weiterhin
          beträchtlich.
        </>
      ),
      links: [
        {
          text: 'SNB sieht UBS und CS gut aufgestellt',
          href: '292836295751',
        },
      ],
    },
  },
  {
    date: '2021-07-13',
    data: {
      date: '13. Juli 2021 ',
      title: 'Zurückstufung',
      text: (
        <>
          Die Ratingagentur Moody’s stuft nach den Vorfällen um die
          Greensill-Fonds und den Milliardenverlust mit dem Archegos-Hedgefonds
          das Kreditrating der CS zurück. Das Langfrist-Rating sinkt um eine
          Stufe auf A1 von zuvor Aa3.
        </>
      ),
    },
  },
  {
    date: '2021-07-26',
    data: {
      date: '26. Juli 2021 ',
      title: 'Aufatmen nach Beschattungsaffäre',
      text: (
        <>
          <Image
            src={require('./Images/kahn.jpg')}
            caption='Iqbal Khan'
            source='Foto: Iris C. Ritter (FuW)'
          />
          Iqbal Khan und seine Frau ziehen ihre Strafanzeige wegen Drohung und
          Nötigung zurück. Die Affäre schwelte seit Herbst 2019, als bekannt
          wurde, dass die CS ihren zur UBS gewechselten Spitzenmanager Khan von
          Detektiven hatte beschatten lassen.
        </>
      ),
      links: [
        {
          text: 'Credit Suisse und Iqbal Khan legen Rechtsstreit bei',
          href: '908065795311',
        },
      ],
    },
  },
  {
    date: '2021-11-01',
    data: {
      date: '1. November 2021 ',
      title: 'Neuer Chef-Aufseher',
      text: (
        <>
          Bei der Finanzmarktaufsicht (Finma) kommt es zum Chefwechsel. Neu
          leitet Urban Angehrn, der ehemalige Anlagechef des Versicherers
          Zurich, die Behörde. Die Finma rügt immer wieder fehlendes
          Risikomanagement bei der CS. Bussen kann sie jedoch nicht erteilen.
        </>
      ),
      links: [
        {
          text: 'Er soll bald UBS und CS zähmen',
          href: '392984002301',
        },
        {
          text: 'Die Finma hat der Credit Suisse mehrmals zu Unrecht vertraut',
          href: '593926898361',
        },
      ],
    },
  },
  {
    date: '2022-01-17',
    data: {
      date: '17. Januar 2022 ',
      title: 'Rücktritt des Präsidenten',
      text: (
        <>
          <Image
            src={require('./Images/osorio.jpg')}
            caption='António Horta-Osório'
            source='Foto: AFP PHOTO/Leon Neal'
          />
          CS-Präsident António Horta-Osório stolpert über Verletzungen der
          Quarantäneregeln. Er soll bei einem Besuch des Tennisturniers in
          Wimbledon Covid-Schutzauflagen missachtet haben. Er zahlt 2000 Franken
          Busse. Auf ihn folgt der ehemalige UBS-Banker Axel Lehmann.
        </>
      ),
      links: [
        {
          text: 'CS-Präsident António Horta-Osório tritt zurück – Aktien fallen',
          href: '595878535905',
        },
      ],
    },
  },
  {
    date: '2022-02-22',
    data: {
      date: '22. Februar 2022 ',
      title: 'Riesiges Datenleck',
      text: (
        <>
          Zeitungen bekommen von einem Whistleblower Daten von mehr als 30’000
          Kunden zugespielt. Die Medien decken auf, dass Kriminelle Konten bei
          der CS eröffnen beziehungsweise Konten auch dann behalten können,
          «wenn die Bank längst hätte wissen können, dass sie es mit Straftätern
          zu tun hat».
        </>
      ),
    },
  },
  {
    date: '2022-02-23',
    data: {
      date: '23. Februar 2022 ',
      title: 'Teurer Betrugsfall',
      text: (
        <>
          Ein Gericht auf den Bermudas verurteilt die CS zu 607 Millionen Dollar
          Schadenersatz. Der ehemalige Bankberater Patrice Lescaudron hatte bei
          reichen Kunden wie dem georgischen Milliardär Bidsina Iwanischwili
          dreistellige Millionenbeträge abgezweigt.
        </>
      ),
      links: [
        {
          text: 'Millionen­teure Gerichts­schlappe der Credit Suisse im Fall Lescaudron',
          href: '433054980406',
        },
        {
          text: 'Credit Suisse soll 607 Millionen Dollar Schadenersatz zahlen',
          href: '894685273954',
        },
      ],
    },
  },
  {
    date: '2022-04-20',
    data: {
      date: '20. April 2022 ',
      title: 'Gewinnwarnung I',
      text: (
        <>
          Die CS gibt bekannt, dass sie im ersten Quartal 2022 in den roten
          Zahlen bleiben wird. Sie muss Rückstellungen für alte Rechtsfälle
          erhöhen. Die Folge: Übernahmespekulationen kommen auf.
        </>
      ),
      links: [
        {
          text: 'Teure Rechtsfälle treiben die  Credit Suisse erneut in die Verlustzone',
          href: '370937176185',
        },
      ],
    },
  },
  {
    date: '2022-06-08',
    data: {
      date: '8. Juni 2022 ',
      title: 'Gewinnwarnung II',
      text: (
        <>
          Sie schreiben auch im zweiten Quartal rote Zahlen, warnt die CS. Sie
          spricht für 2022 von einem «Übergangsjahr». Die Übernahmegerüchte
          verstärken sich, was der Aktie Auftrieb gibt.
        </>
      ),
      links: [
        {
          text: 'Credit Suisse rechnet erneut mit einem Verlust',
          href: '210305753836',
        },
      ],
    },
  },
  {
    date: '2022-06-28',
    data: {
      date: '28. Juni 2022 ',
      title: 'Neuer Optimismus',
      text: (
        <>
          Bankchef Thomas Gottstein versucht mit seiner neuen Führungsriege an
          einer Investorenkonferenz in London, Aktionäre und Kunden von den
          Fortschritten der Bank zu überzeugen. Es gehe darum, eine neue CS zu
          bauen, die widerstandsfähiger und konkurrenzlos stark bei der
          Kundenbetreuung sei.
        </>
      ),
      links: [
        {
          text: 'Wie die Credit Suisse aus der Krise finden will',
          href: '662628276794',
        },
      ],
    },
  },
  {
    date: '2022-07-27',
    data: {
      date: '27. Juli 2022 ',
      title: 'Schon wieder ein Wechsel an der Spitze',
      text: (
        <>
          <Image
            src={require('./Images/koerner.jpg')}
            caption='Ulrich Körner'
            source='Foto: PD'
          />
          Kurz bevor die CS ein miserables Halbjahresergebnis vorlegt, geht
          Bankchef Gottstein. Unter seiner Führung hatte die Bank die
          Zusammenbrüche von Greensill und Archegos erlitten. Neuer Chef wird
          Ulrich Körner – eine grosse Sparrunde folgt.
        </>
      ),
      links: [
        {
          text: 'Credit-Suisse-Chef Thomas Gottstein steht vor Rücktritt',
          href: '364390917847',
        },
      ],
    },
  },
  {
    date: '2022-08-11',
    data: {
      date: '11. August 2022 ',
      title: 'Grossaktionär verdoppelt Beteiligung',
      text: (
        <>
          Harris Associates erhöht ihre Beteiligung an der CS auf 10 Prozent.
          Damit liegen die Amerikaner nun weit vor den anderen Grossaktionären
        </>
      ),
      links: [
        {
          text: 'CS-Grossaktionär Harris verdoppelt Beteiligung',
          href: '518220562207',
        },
      ],
    },
  },
  {
    date: '2022-10-03',
    data: {
      date: '3. Oktober 2022 ',
      title: 'Memo sorgt für Panik',
      text: (
        <>
          «Ich hoffe, dass Sie unsere tägliche Kursentwicklung nicht mit der
          starken Kapital- und Liquiditätsposition der Bank verwechseln»,
          schreibt Bankchef Körner in einem Memo. Er will damit für Beruhigung
          sorgen – schürt jedoch Verunsicherung: Wie muss es um die Stabilität
          stehen, wenn der Chef diese derart stark betont?
        </>
      ),
      links: [
        {
          text: 'Credit Suisse sorgt mit vermeintlicher Beruhigungsspritze für Panik',
          href: '785850667340',
        },
      ],
    },
  },
  {
    date: '2022-10-27',
    data: {
      date: '27. Oktober 2022 ',
      title: 'Der Sturm bricht los - die Kunden sind beunruhigt',
      text: (
        <>
          In den sozialen Medien wird heftig über die Zukunft der Bank
          spekuliert. Der Aktienkurs schwankt.
        </>
      ),
      links: [
        {
          text: 'CS-Aktien nach Strategie-Update massiv unter Druck',
          href: '708849287940',
        },
        {
          text: 'Was passiert, wenn der Staat die CS retten muss?',
          href: '474587600441',
        },
      ],
    },
  },
  {
    date: '2022-11-23',
    data: {
      date: '23. November 2022 ',
      title: 'Gewinnwarnung III',
      text: (
        <>
          Die CS gibt bekannt, dass Kunden Gelder abgezogen haben, und erwartet
          einen Verlust für das Schlussquartal des Jahres 2022. Die Aktie bricht
          ein, obwohl die Aktionäre einer vier Milliarden schweren
          Kapitalerhöhung durch die neuen saudischen Grossaktionäre zustimmen.
        </>
      ),
      links: [
        {
          text: 'Saudi-Einstieg, Aktie floppt, Verlust – Ein denkwürdiger Tag für die CS',
          href: '476517776719',
        },
      ],
    },
  },
  {
    date: '2023-01-18',
    data: {
      date: '18. Januar 2023 ',
      title: 'Beruhigungsversuche',
      text: (
        <>
          «Die Abflüsse sind, wie bereits gesagt, sehr stark zurückgegangen»,
          sagt Bankchef Körner in einem Interview am WEF. Er hatte dies schon im
          Dezember in einem Interview beteuert. Die Aussage sollte sich als
          falsch herausstellen, weswegen sich die Finanzmarktaufsicht
          einschaltet.
        </>
      ),
    },
  },
  {
    date: '2023-02-09',
    data: {
      date: '9. Februar 2023 ',
      title: 'Hohe Verluste und verunsicherte Investoren',
      text: (
        <>
          Die CS gibt für 2022 einen Verlust von über sieben Milliarden Franken
          bekannt. Grund dafür sind hohe Kosten, drastische Wertberichtigungen
          und der Abfluss von Kundengeldern.
        </>
      ),
      links: [
        {
          text: 'Horrorjahr für die Credit Suisse',
          href: '847964381340',
        },
      ],
    },
  },
  {
    date: '2023-03-06',
    data: {
      date: '6. März 2023 ',
      title: 'Grossaktionär stösst CS-Paket ab',
      text: (
        <>
          Einer der wichtigsten Grossaktionäre der Bank, Harris Associates,
          verkauft sämtliche Credit-Suisse-Aktien und lässt kein gutes Haar am
          Führungsduo.
        </>
      ),
      links: [
        {
          text: 'Er lässt kein gutes Haar am Führungsduo der Credit Suisse',
          href: '578694082816',
        },
      ],
    },
  },
  {
    date: '2023-03-09',
    data: {
      date: '9. März 2023 ',
      title: 'Berichts-Debakel',
      text: (
        <>
          Die CS verschiebt überraschend die Veröffentlichung ihres
          Jahresberichts. Grund sind offene Fragen der US-Börsenaufsicht SEC zum
          Jahresbericht. Die Aktie verliert erneut an Wert.
        </>
      ),
      links: [
        {
          text: 'Neuer Chaostag bei der Credit Suisse – was ist da los?',
          href: '682932157497',
        },
      ],
    },
  },
  {
    date: '2023-03-13',
    data: {
      date: '11. und 12. März 2023 ',
      title: 'Bankenkrise in den USA nimmt ihren Lauf',
      text: (
        <>
          In den USA geraten zwei Banken in Schieflage und werden geschlossen –
          die Silicon Valley Bank und die Signature Bank in New York, eine der
          wichtigsten Banken für Krypto-Unternehmen. Die Szenen wecken
          Erinnerungen an die Finanzkrise 2007/2008. Weltweit brechen Bankaktien
          ein.
        </>
      ),
      links: [
        {
          text: 'Zweite US-Bank ist pleite, Biden verweigert Rettung, CS-Aktie sackt ab',
          href: '913485545921',
        },
      ],
    },
  },
  {
    date: '2023-03-15',
    data: {
      date: '15. März 2023 ',
      title: 'Saudis reagieren',
      text: (
        <>
          Der wichtigste Aktionär, die Saudi National Bank, spricht der CS ihr
          Vertrauen aus, will aber kein weiteres Geld mehr einschiessen. Die
          Aktie stürzt so stark ab, dass sie teilweise vom Handel ausgesetzt
          wird.
        </>
      ),
      links: [
        {
          text: 'Der Schwarze Mittwoch der Credit Suisse – das Protokoll',
          href: '549650959026',
        },
      ],
    },
  },
  {
    date: '2023-03-16',
    data: {
      date: '16. März 2023 ',
      title: 'Notenbank-Kredit',
      text: (
        <>
        In der Nacht von Mittwoch auf Donnerstag erhält die CS eine Finanzspritze über 50 Milliarden Franken von der Schweizerischen Nationalbank (SNB). Die Aktie startet mit einem Plus von über 30 Prozent in den Tag – schon bald bröckelt der Kurs allerdings wieder. Der Bundesrat trifft sich zu einer Sondersitzung, meldet sich öffentlich aber nicht zu Wort. Auch SNB und Finanzmarktaufsicht äussern sich den ganzen Tag nicht. Bei Börsenschluss ist die Aktie wieder mehr als 2 Franken wert.
        </>
      ),
      links: [
        {
          text: 'Das sind die Bedingungen für die Finanzspritze der Nationalbank an die CS',
          href: '595209020740',
        },
      ],
    },
  },
  {
    date: '2023-03-17',
    data: {
      date: '17. März 2023 ',
      title: 'Die Pille verliert an Wirkung',
      text: (
        <>
        Auch am zweiten Tag nach der Finanzhilfe bleibt der Bundesrat stumm. Er trifft sich zwar zu einer regulären Sitzung, die Bundeskanzlei teilt aber schon am Morgen mit, dass es keine Pressekonferenz geben wird. Eine Interpretation des Schweigens ist, dass im Hintergrund weitere Massnahmen vorbereitet werden. Es kursieren erste Gerüchte, die Behörden könnten am Wochenende informieren. 
        Der Aktienkurs der Credit Suisse verliert am Nachmittag bis zu 13 Prozent. Die Europäische Zentralbank trifft sich zu einer Krisensitzung, neue beunruhigende Zahlen zu den Geldabflüssen bei der CS werden bekannt.
        </>
      ),
      links: [
        {
          text: 'Wieso schweigt der Bundesrat?',
          href: '659609914567',
        },
      ],
    },
  },
]
